<template>
  <b-modal
      v-model="show"
      v-if="show"
      centered
      hide-footer
      :title="editing ? 'ویرایش بودجه' : 'افزودن بودجه جدبد'"
      :no-close-on-backdrop="true"
      size="md"
  >
    <b-row>
      <b-col class="col-md-6">
        <b-form-group
            label="اتریبیوشن"
            label-for="Attribution"
            class="d-inline-block full-width"
        >
          <v-select
              ref="Attribution"
              v-model="form.AdsAttributionId"
              dir="rtl"
              :reduce="x => x.Id"
              label="Title"
              input-id="Attribution"
              :clearable="false"
              :options="attributions"
              @open="getAttributions"
          >
            <span
                slot="no-options"
                @click="$refs.Attribution.open = false"
            >
              {{ $t('common.noOptions') }}
            </span>
            <template #spinner>
              <div class="demo-inline-spacing">
                <b-spinner
                    v-if="campaignLoading"
                    class="m-0"
                    small
                    variant="secondary"
                />
              </div>
            </template>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="مقدار"
            label-for="Amount"
        >
          <b-form-input
              id="Amount"
              v-model="form.Amount"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="از تاریخ"
            label-for="StartDate"
        >
          <date-picker
              v-model="form.FromDate"
              placeholder=""
              type="date"
              format="YYYY-MM-DD"
              display-format="jYYYY-jMM-jD"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="تا تاریخ"
            label-for="EndDate"
        >
          <date-picker
              v-model="form.ToDate"
              placeholder=""
              type="date"
              format="YYYY-MM-DD"
              display-format="jYYYY-jMM-jD"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <div class="text-center mt-2">
      <b-overlay :show="loading" rounded spinner-small class="d-inline-block">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            :disabled="loading"
            @click="submit"
        >
          ذخیره
        </b-button>
      </b-overlay>
      <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          @click="$emit('update:show', !show)"
      >
        انصراف
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "chargeForm",
  props: {
    show: { type: Boolean, default: false },
    item: { type: Object, default: null },
    attributions: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      form: {
        AdsAttributionId: '',
        Amount: '',
        FromDate: '',
        ToDate: ''
      }
    }
  },
  computed: {
    editing() {
      return this.item && this.item.Id
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (!val) this.form = {
          AdsAttributionId: '',
          Amount: '',
          FromDate: '',
          ToDate: ''
        }
      }
    },
    item: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getAttributions()
          this.form = val
        }
      }
    }
  },
  methods: {
    submit() {
      this.loading = true
      let url = this.editing ? this.$api.charges.update : this.$api.charges.add
      this.$http.post(url, this.form).then(() => {
        this.loading = false
        this.$emit('update:show', !this.show)
        this.$emit('update')
      }).finally(() => {
        this.loading = false
      })
    },
    getAttributions() {
      if (this.attributions.length) return
      this.$http.get(this.$api.campaigns.getAll).then(response => {
        this.$emit('update:attributions', response.data)
      }).catch(er => {
        console.log(er)
      })
    }
  }
}
</script>